import React, { useState } from 'react';
import { js_utils } from '../utils/frfr-js-utils';
import ColumnWidthMinimize from './ColumnWidthMinimize';
import JSDisplayValue from './JSDisplayValue';
import JSDisplayWidgetCollapsibleHeight from './JSDisplayWidgetCollapsibleHeight';
// import { assets } from '../assets/assets';
import { VscListTree } from "react-icons/vsc";

const JSDisplayObject = (props) => {
  let obj = props.val;
  let initialDisplayStyle = 0; // DEFAULT 0 Vertical list
  if (props.initialHorizontal === true) {
    initialDisplayStyle = 1;
  }
  const [displayStyle, setDisplayStyle] = useState(initialDisplayStyle); // 0 Vertical list, 1 Horizontal, 2 Tree mode
  // console.log(Object.entries(obj));
  /*
  let jsxTableRows = Object.entries(obj).map((el) => {
    // console.log(el);
    let key = el[0];
    let value = el[1];
    return (
      <tr key={key} className={""}>
        <td className="frfr-js-table__keyval-row__key">{key}</td>
        <td className="val"><JSDisplayValue val={value} cb={props.cb} primitive_validator={props.primitive_validator} key_name={key} /></td>
      </tr>
    );
  });
  */
  /*
  <svg fill="#000000" height="800px" width="800px" id="Layer_1" data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path class="cls-1" d="M10,5V7h4V9H10v2h4v2H8V5H5V3h9V5ZM2,5H4V3H2Zm5,6H5v2H7ZM7,7H5V9H7Z"/>
  </svg>

  <img className="" src={assets.icons.list_tree_svgrepo} alt="tree view" />

  <i className="fa fa-list-ul" aria-hidden="true"></i>

  <VscListTree />

  <svg fill="currentColor" height="800px" width="800px" id="Layer_1" data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path class="cls-1" d="M10,5V7h4V9H10v2h4v2H8V5H5V3h9V5ZM2,5H4V3H2Zm5,6H5v2H7ZM7,7H5V9H7Z" />
  </svg>
  */
  return (
    <ColumnWidthMinimize>
      <div className="frfr-js-display-object-widget">
        <div className="frfr-js-display-object-widget__xi-header"><span className="frfr-js-display-object-widget__xi-header__notation"><span>{'{'}</span><span>{'}'}</span></span><span className="frfr-js-display-object-widget__xi-header_title">Object</span>
          <span className={(displayStyle === 0 ? "frfr-js-display-object-widget__xi-header__icon frfr-js-display-object-widget__xi-header__icon--active" : "frfr-js-display-object-widget__xi-header__icon")} onClick={() => { setDisplayStyle(0) }}><abbr title="List">{/*<i className="fa fa-list" aria-hidden="true"></i>*/}<i className="fa fa-long-arrow-down" aria-hidden="true"></i></abbr></span>
          <span className={(displayStyle === 1 ? "frfr-js-display-object-widget__xi-header__icon frfr-js-display-object-widget__xi-header__icon--active" : "frfr-js-display-object-widget__xi-header__icon")} onClick={() => { setDisplayStyle(1) }}><abbr title="Horizontal list"><i className="fa fa-long-arrow-right" aria-hidden="true"></i></abbr></span>
          <span className={(displayStyle === 2 ? "frfr-js-display-object-widget__xi-header__icon frfr-js-display-object-widget__xi-header__icon--active" : "frfr-js-display-object-widget__xi-header__icon")} onClick={() => { setDisplayStyle(2) }}><abbr title="Tree list">
            <VscListTree />
          </abbr></span>
        </div>
        <div className="frfr-js-display-object-widget__xi-body">

          <JSDisplayWidgetCollapsibleHeight>
            {
              js_utils.is_object(obj) ? (
                <>
                  {
                    displayStyle === 1 && (
                      <table className="frfr-js-table frfr-js-table__keyval-list-horizontal">
                        <thead>
                          <tr>
                            <th scope="row" className="frfr-js-table__keyval-list-horizontal__key"><span>key</span></th>
                            {
                              Object.keys(obj).map((key, index) => {
                                return (
                                  <th key={key} className="frfr-js-table__keyval-column__key"><span>{key}</span></th>
                                );
                              })
                            }
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="column" className="frfr-js-table__keyval-column__val"><span>value</span></th>
                            {
                              Object.entries(obj).map((el) => {
                                // console.log(el);
                                const key = el[0];
                                const value = el[1];
                                return (
                                  <td key={key} className="frfr-js-table__keyval-column__val"><JSDisplayValue val={value} cb={props.cb} primitive_validator={props.primitive_validator} /></td>
                                );
                              })
                            }
                          </tr>
                        </tbody>
                      </table>
                    )
                  }
                  {
                    displayStyle === 0 && (
                      <table className="frfr-js-table frfr-js-table__keyval-list-vertical">
                        <thead>
                          <tr>
                            <th className="frfr-js-table__keyval-row__key"><span>key</span></th>
                            <th className="frfr-js-table__keyval-row__val"><span>value</span></th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            Object.entries(obj).map((el) => {
                              // console.log(el);
                              const key = el[0];
                              const value = el[1];
                              return (
                                <tr key={key} className={""}>
                                  <th scope="row" className="frfr-js-table__keyval-row__key"><span>{key}</span></th>
                                  <td className="frfr-js-table__keyval-row__val"><JSDisplayValue val={value} cb={props.cb} primitive_validator={props.primitive_validator} key_name={key} /></td>
                                </tr>
                              );
                            })
                          }
                        </tbody>
                      </table>
                    )
                  }
                  {
                    displayStyle === 2 && (
                      <>
                        <div className="frfr-js-display-tree">
                          <div className="frfr-js-display-tree__object-start"><span>{'{'}</span></div>
                          <div className="frfr-js-display-tree__object-start frfr-js-display-tree__object-start--when-closed"><span>{'{'}</span>...<span>{'}'}</span></div>
                          <div className="frfr-js-display-tree__object-keyval-list">
                            {
                              Object.entries(obj).map((el) => {
                                // console.log(el);
                                const key = el[0];
                                const value = el[1];
                                return (
                                  <div key={key} className="frfr-js-display-tree__keyval-pair">
                                    <div className="frfr-js-display-tree__keyval-pair__key"><span>{key}</span></div>
                                    <div className="frfr-js-display-tree__keyval-pair__keyval-separator">:</div>
                                    <div className="frfr-js-display-tree__keyval-pair__val">
                                      <JSDisplayValue val={value} cb={props.cb} primitive_validator={props.primitive_validator} key_name={key} />
                                    </div>
                                  </div>
                                );
                              })
                            }
                          </div>
                          <div className="frfr-js-display-tree__object-end"><span>{'}'}</span></div>
                        </div>
                      </>
                    )
                  }
                </>
              ) : (
                <div className="frfr-js-display-velue-error-msg"><span>ERROR: Value is not an Object!</span></div>
              )
            }
          </JSDisplayWidgetCollapsibleHeight>

        </div>
      </div>
    </ColumnWidthMinimize>
  );
};

export default JSDisplayObject;